export default function Artcompany() {
  return (
    <div className="hero">
      <img
        src="https://static.igem.wiki/teams/4260/wiki/imagen/team/compania/compa-ia-1.jpg"
        alt="background"
        style={{ width: "100vw" }}
      />
      <div className="w-full h-full py-24 px-16">
        <h2 className="text-4xl" style={{ color: "rgb(213,179,252)" }}>
          Tec de Monterrey's
        </h2>
        <h1 className="cano text-6xl" style={{ color: "rgb(213,179,252)" }}>
          <font style={{ color: "rgb(138, 224, 250)" }}>Art </font>
          and <font style={{ color: "rgb(250, 250, 138)" }}>Design</font>{" "}
          Company
        </h1>
        <div className="glass max-w-3xl text-white py-4 px-8 rounded-md mt-8"  style={{backgroundColor: 'rgba(213,179,252,.25)'}}>
          <p className="p">
            The Art & Design Company, in Spanish “Compañía de Arte y Diseño”, is
            a representative group hailing from Tecnológico de Monterrey Campus
            Estado de México. Comprised of a multidisciplinary team of high
            school and university students and led by their founder, professor
            Sandra Santos, and their coach, Manu Caudillo, it is always creating
            diverse artworks from a wide variety of both analogous and digital
            techniques, constantly standing out for the quality and originality
            of their works.
          </p>
          <p className="p">
            Inside the campus grounds, the Art & Design Company often creates
            banners, advertisement material for campus events, theatre props and
            scenography, as well as art installations for the various festivals
            that take place throughout the year. However, they can also be found
            outside of their designated studio, painting murals in the nearby
            elementary schools while leading large teams of volunteers,
            imparting community art classes, and even sending out their work to
            expositions such as Mexicráneos. Most recently, the Art & Design
            Company has started collaborating with other student groups and
            institutions, such as Crecemos Leyendo, a voluntary work
            organization that facilitates affordable literature for low-income
            children, or the Instituto de Investigaciones Estéticas from UNAM,
            one of Mexico’s most highly regarded universities.
          </p>
          <p className="p mb-8">
            {" "}
            This collaboration with IGEM CEM is one that fills us with pride and
            expectation: eight months of hard work are finally coming to
            fruition, and, we hope, are only the beginning to a long
            withstanding relationship between the two representative groups at
            Tec de Monterrey.
          </p>
        </div>
      </div>
    </div>
  );
}
